import { Col, Form, Input, Modal, notification, Radio, Row, Upload } from 'antd';
import { UploadFile, UploadProps } from 'antd/es/upload';
import React, { FC, useState } from 'react';
import { uploadDocument } from '../../manage-reestr-list/actions';
import Button from '/react4xp/mixins/ui/button/button';

const ManageReestrAddItemModal: FC = (props: any) => {
    const [lang, setLang] = useState<string>('rus');
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [uploading, setUploading] = useState(false);
    const [form] = Form.useForm();

    const fileProps: UploadProps = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                const isLt15M = file.size / 1024 / 1024 < 15;
                if (isLt15M) {
                    setFileList([file]);
                } else {
                    notification['warning']({
                        message: 'Файл превысил максимально допустимый размер равный 15 МБ!',
                    });
                }
            } else {
                notification['warning']({
                    message: 'Формат загружаемого материала не соответствует параметрам!',
                    description: 'Файл должен иметь расширение: .xls, .xlsx',
                });
            }

            return false;
        },
        fileList,
    };

    const handleOk = () => {
        form.validateFields().then(() => {
            const { name } = form.getFieldsValue();
            const [file] = fileList;

            if (file) {
                const bodyFormData = new FormData();
                bodyFormData.append('name', name);
                bodyFormData.append('file', file);
                bodyFormData.append('language', lang);
                bodyFormData.append('username', props.user.displayName);
                bodyFormData.append('documentCategory', props.category.documentCategory);

                setUploading(true);

                uploadDocument(bodyFormData)
                    .then((value) => {
                        notification['success']({
                            message: 'Файл добавлен успешно!',
                            description: value,
                        });
                        props.handleOk();
                        form.resetFields();
                        setFileList([]);
                    })
                    .finally(() => setUploading(false));
            } else {
                notification['warning']({
                    message: 'Файл не выбран!',
                });
            }
        });
    };

    const handleCancel = () => {
        props.handleCancel();
        form.resetFields();
        setFileList([]);
    };

    return (
        <Modal
            title="Добавить новый файл"
            open={props.isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button
                    type="primary admin"
                    key="back"
                    onClick={handleCancel}
                >
                    Отмена
                </Button>,
                <Button
                    key="submit"
                    type="primary admin"
                    onClick={handleOk}
                    loading={uploading}
                >
                    Добавить
                </Button>,
            ]}
        >
            <div>
                <Radio.Group
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}
                >
                    <Radio.Button value="kaz">Қазақша</Radio.Button>
                    <Radio.Button value="rus">Русский</Radio.Button>
                    <Radio.Button value="en">English</Radio.Button>
                    <Radio.Button value="qq">Qazaqsha</Radio.Button>
                </Radio.Group>
            </div>
            <div className="my-3">
                <Form
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label="Название"
                        name="name"
                        rules={[
                            { required: true, message: 'Это поле обязательно для заполнения!' },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <hr className="my-3" />
                    <Row gutter={16}>
                        <Col>
                            <Upload
                                {...fileProps}
                                accept=".xlsx"
                            >
                                <Button type="primary admin">Выберите файл</Button>
                            </Upload>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Modal>
    );
};

export default ManageReestrAddItemModal;
